import { isObject } from './obj';
import { getMimetype } from './mimetypes';
var filterSource = function filterSource(src) {
    if (Array.isArray(src)) {
        var newsrc = [];
        src.forEach(function (srcobj) {
            srcobj = filterSource(srcobj);
            if (Array.isArray(srcobj)) {
                newsrc = newsrc.concat(srcobj);
            } else if (isObject(srcobj)) {
                newsrc.push(srcobj);
            }
        });
        src = newsrc;
    } else if (typeof src === 'string' && src.trim()) {
        src = [fixSource({ src: src })];
    } else if (isObject(src) && typeof src.src === 'string' && src.src && src.src.trim()) {
        src = [fixSource(src)];
    } else {
        src = [];
    }
    return src;
};
function fixSource(src) {
    var mimetype = getMimetype(src.src);
    console.log('fixSource\uFF1A', !src.type, mimetype);
    if (!src.type && mimetype) {
        src.type = mimetype;
    }
    return src;
}
export default filterSource;